import React from 'react';
import Page from '../components/Page';
import { Container, Grid } from '@mui/material';
import SuperCapstonePartner from '../components/_dashboard/supercapstonepartner';

const SuperCapstone = () => {
  return (
    <Page title='Dashboard | Capstone'>
      <Container maxWidth='xl'>
        <Grid item xs={12} sm={12} md={12}>
          <SuperCapstonePartner/>
        </Grid>
      </Container>
    </Page>
  );
};

export default SuperCapstone;
